import React, { Component } from 'react';
import './Haisbaglimail.css';
//import mdem from '../../images/public/registeration/mdem.png';
import clos from '../../images/public/registeration/clos.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { BrowserView, MobileView } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import Confermail from '../Confermail/Confermail';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
//import Termini from '../Termini/Termini';
import { modifyEmail } from '../../libs/fetch';
//import Cookies from 'universal-cookie';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import itabar1 from '../../images/public/registeration/nav1i.png';
//import engbar1 from '../../images/public/registeration/nav1e.png';
//import simplebar1 from '../../images/public/registeration/mobilenav1.png';
import logo from '../../images/public/login/logo.png';
//import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
//import miniArrow from '../../images/public/registeration/miniarrow.png';
import TopBar from '../../assets/components/topbar/TopBar';
//import help from '../../images/public/userarea/tab5u.png';

let user;

class Haisbaglimail extends Component {
	constructor(props) {
		super(props);

		//let params = null;
		this.state = {
			step: '1',
			email: '',
			oldemail: '',
			userInfo: null,
			emailErr: false,
			backto: null,
		};

		this.handleChangeEmailAddres = this.handleChangeEmailAddres.bind(this);
		this.gotoTerminil = this.gotoTerminil.bind(this);
		}


		/* Life Cycle*/
		componentDidMount = () => {

				if (!localStorage.getItem('user')) {
						return this.props.history.push('/');
				}

				user = JSON.parse(localStorage.getItem('user'));
				let backto = localStorage.getItem('backto');
				this.setState({ backto });
		}

		canBeSubmitted = () => {
				return (!this.state.emailErr && this.state.email !== '');
		}

		validateInput = () => {
				return this.validateEmail(this.state.email);
		}

		gotoTerminil = (e) => {

				e.preventDefault();

				console.log("gotoTerminil: !!start!!: ")
				console.log(user);


				if (this.canBeSubmitted() && this.validateInput()) {

						// Rest Call
						try {
								//TODO  old emailò
								modifyEmail(this, {
										oldEmail: user.email,
										email: this.state.email,
										one_step: 1,
										language: tr.userlng(),
										portal: "sci"
								}).then((response) => {
										console.log("modifyEmail: response: ", response)

										if (response === null) {
												return;
										}

										if (response.status === "fail") {
												// alert(response.message);
												this.handleAlert(response.message);
												console.log("modifyEmail: !!FAIL!!: ", response.message)
												this.setState({ emailErr: true })

										}
										if (response.status === "success") {

												// alert(tr.t("success"))
												this.handleAlert(tr.t("success"));

												// update user mail in storage
												user.email = this.state.email;
												localStorage.setItem('user', JSON.stringify(user));

												this.props.history.push({
														pathname: this.state.backto === 'userarea' ? '/' : '/confirm'
												});

										}


								});

						} catch (error) {

								// alert(error)
								this.handleAlert(error);
						}
				}
				else {
						this.setState({ emailErr: true })
				}

				return
		}

		validateEmail = () => {

				var mail = this.state.email;
				var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
				var validEmail = regexp.test(this.state.email);
				this.setState({ emailErr: !validEmail });
				return validEmail;

		}

		handleChangeEmailAddres = (e) => {
				e.preventDefault();
				this.setState({ email: e.target.value }, () => this.validateEmail());
				return
		}

		alertResponse(info) {
			switch (info.type) {
				case "closeButton":
					this.setState({ inScreenPopupShow: false })
					break;
				case "actionButton":
					if (info.option1 === "attention") 
						this.setState({ inScreenPopupShow: false })
					break;
				default:
					break;					
			}
		}

		// Default browser alert function replacement
		handleAlert = (incomingMsg) => {
				console.log("Incoming message:", incomingMsg);
				this.setState({
						inScreenPopupShow: true,
						inScreenPopupMsg: incomingMsg,
				})
		}

		render() {

				const isDisabled = !this.canBeSubmitted();
				//console.log('render', isDisabled);
				return (
					<Router>
						<div>
							<div>
								<BrowserView>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { this.props.history.goBack(); }}>
														<img src={clos} alt=""/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
									<div className="sn_overlay d-lg-none"></div>
										<div className="sn_editmail">
											<div className="container">
												<div className="row">
													<div className="col-12 col-lg-7 mx-auto"> 
														<div className="sn_register__container">
															<div className="row d-none d-lg-flex">
																<div className="col-12 d-flex justify-content-end">
																	<div className="sn_exit">
																		<a onClick={() => { this.props.history.goBack(); }}>
																			<img src={clos} alt=""/>
																		</a>
																	</div>
																</div>
															</div>
															<div className="row mb-4">
																<div className="col-12">
																	<h3 className="text-center">{ tr.t("Changee") }</h3>
																	<p className="text-center">{ tr.t("Insertynmail") }</p>														
																	<input
																		type="text"
																		spellCheck={false}
																		name="mail"
																		placeholder="email@mail.com"
																		className={(this.state.emailErr) ? "err_red sn_input" : "err_no sn_input"}
																		maxLength="50" onChange={this.handleChangeEmailAddres} value={this.state.email}
																	/>
																</div>
															</div>
															<div className="row">
																<div className="col-12 d-flex justify-content-center justify-content-sm-end">
																	<button className="sn_btn" onClick={this.gotoTerminil} disabled={isDisabled}>{tr.t("Save")}</button>
																</div>
															</div>
														</div>
													</div> 
												</div> 
											</div>
										</div>
								</BrowserView>
								<MobileView>
								<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row flex-nowrap">
											<div className="col-2 d-flex align-items-center">
											{/*
												<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											*/}
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
											</div>
											<div className="col-2 d-flex align-items-center justify-content-end">
												<div className="sn_exit">
													<a onClick={() => { this.props.history.goBack(); }}>
														<img src={clos} alt=""/>
													</a>
												</div>
											</div>
										</div>
									</div>
									<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
									<div className="sn_overlay d-lg-none"></div>
										<div className="sn_editmail">
											<div className="container">
												<div className="row">
													<div className="col-12 col-lg-7 mx-auto"> 
														<div className="sn_register__container">
															<div className="row d-none d-lg-flex">
																<div className="col-12 d-flex justify-content-end">
																	<div className="sn_exit">
																		<a onClick={() => { this.props.history.goBack(); }}>
																			<img src={clos} alt=""/>
																		</a>
																	</div>
																</div>
															</div>
															<div className="row mb-4">
																<div className="col-12">
																	<h3 className="text-center">{ tr.t("Changee") }</h3>
																	<p className="text-center">{ tr.t("Insertynmail") }</p>														
																	<input
																		type="text"
																		spellCheck={false}
																		name="mail"
																		placeholder="email@mail.com"
																		className={(this.state.emailErr) ? "err_red sn_input" : "err_no sn_input"}
																		maxLength="50" onChange={this.handleChangeEmailAddres} value={this.state.email}
																	/>
																</div>
															</div>
															<div className="row">
																<div className="col-12 d-flex justify-content-center justify-content-sm-end">
																	<button className="sn_btn" onClick={this.gotoTerminil} disabled={isDisabled}>{tr.t("Save")}</button>
																</div>
															</div>
														</div>
													</div> 
												</div> 
											</div>
										</div>
								</MobileView>
								</div>
								{
									this.state.inScreenPopupShow ?
									<div className="containerModal">
									{   
										this.state.inScreenPopupShow ?
										<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.inScreenPopupMsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"medium"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
									}
									</div> : null
								}
								</div>
						</Router>
				);
		}
}

export default Haisbaglimail;


// WEBPACK FOOTER //
// ./src/screens/Haisbaglimail/Haisbaglimail.js